import React from 'react';
import {Layer} from "react-map-gl/mapbox";
import {CircleLayerSpecification} from "mapbox-gl";
import {useDateNowMsInterval} from "../../../hooks/useDateNowMsInterval";

// Types ----

type VisitorLocationLayerProps = {
  id: string
  source?: string
}

// Component ----

function VisitorLocationsLayer({id, source}: VisitorLocationLayerProps) {
  const dateNowMs = useDateNowMsInterval(5000);
  const oneMinuteInMs = 60_000;
  const oneMinuteAgoMs = dateNowMs - oneMinuteInMs;

  const circlePaintColor: CircleLayerSpecification['paint'] = {
    'circle-color': [
      'case',
      ['>=', ['get', 'occurred_at'], oneMinuteAgoMs],
      '#f59e0b',
      '#666666'
    ],
  };

  return (
    <>
      <Layer
        id={`${id}-circle`}
        source={source}
        type="circle"
        minzoom={12}
        paint={{...circlePaint, ...circlePaintColor}}
      />
    </>
  );
}

// Styles ----

const circlePaint: CircleLayerSpecification['paint'] = {
  'circle-stroke-color': 'white',
  'circle-stroke-width': 1,
  "circle-radius": [
    "interpolate",
    ["linear"],
    ["zoom"],
    12, 3,
    13, 3,
    14, 3,
    15, 3,
    16, 4,
    17, 5,
    18, 6,
    19, 11,
    20, 13,
    21, 19,
    22, 21
  ],
};

// Export ----

export default VisitorLocationsLayer;
